import { store } from "store";
import { Change } from "types";
import { generateAction } from "create_change";
import { createConsumer, Subscription, Consumer } from "@rails/actioncable";
import {
  fullSync,
  fullSyncNoMutex,
  getChecklist,
  ChangeMutex,
} from "changes_sync";

let subscription: Subscription<Consumer>;

export const initActionCable = () => {
  if (!subscription) {
    subscription = initActionCableInner();
  }
};
const initActionCableInner = () => {
  return createConsumer().subscriptions.create(
    {
      channel: "ChecklistsChannel",
      checklist_url_path: window.location.pathname,
    },
    {
      received: applyChange,
      connected: fullSync,
    },
  );
};
export const applyChange = async (newChange: Change) => {
  await ChangeMutex.runExclusive(
    async () => await applyChangeNoMutex(newChange),
  );
};

const applyChangeNoMutex = async (newChange: Change) => {
  const checklist = getChecklist();

  // checklist could be null if we receive a new change before the initial fullSync
  // in that case schedule a new fullSync
  if (!checklist) {
    await fullSyncNoMutex();
    return;
  }

  const existingChange = checklist.changes.find((_) => _.id === newChange.id);
  if (existingChange) {
    return;
  }

  if (newChange.created_at > (checklist.newest_synced_change_created_at || 0)) {
    store.dispatch(generateAction(newChange));
  }
};
